import { createSlice } from '@reduxjs/toolkit'

import { addExtraReducer } from '../../../../store/addExtraReducer'

import initialState from './initialState'
import {
  CreateBrokerIdentifierReducer,
  DeleteBrokerIdentifierReducer,
  GetBrokerIdentifiersReducer,
} from './reducers'
import {
  CreateBrokerIdentifier,
  DeleteBrokerIdentifier,
  GetBrokerIdentifiers,
  SLICE_NAME,
} from './thunks'

const BrokerIdentifiersSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    addExtraReducer(builder, GetBrokerIdentifiers, GetBrokerIdentifiersReducer)
    addExtraReducer(builder, CreateBrokerIdentifier, CreateBrokerIdentifierReducer)
    addExtraReducer(builder, DeleteBrokerIdentifier, DeleteBrokerIdentifierReducer)
  },
})

export default BrokerIdentifiersSlice.reducer
